import { subscriptionsBaseApiUrl } from "../../subscriptionsBaseUrl";

export const subscriptionUrlSubscriptionManagement = `${subscriptionsBaseApiUrl}/SubscriptionManagement`;

export const subscriptionItemsKey = "subscriptionItems";
